import PropTypes from "prop-types";

import LoaderIcon from "assets/svg/loader.svg";

import styles from "./styles.module.css";

const Loader = () => {
  return (
    <div className={styles.wrapper}>
      <LoaderIcon />
    </div>
  );
};

Loader.propTypes = {
  children: PropTypes.node,
};

export default Loader;
